import { render, staticRenderFns } from "./SwiperBanner.vue?vue&type=template&id=55381db8&scoped=true&"
import script from "./SwiperBanner.vue?vue&type=script&lang=js&"
export * from "./SwiperBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55381db8",
  null
  
)

export default component.exports